"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Warning = _interopRequireDefault(require("@p24/icons/Warning"));

function _default(palette) {
  return {
    palette: palette,
    color: palette.tError,
    textAlign: 'left',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    fontSize: palette.tsNormal,
    lineHeight: palette.tlNormal,
    fontWeight: palette.twNormal,
    margin: 'auto',
    background: 'transparent',
    warningIcon: _Warning["default"],
    field: {
      fontSize: palette.tsXSmall,
      lineHeight: palette.tlXSmall,
      paddingTop: palette.gutter + 'px'
    },
    form: {
      margin: "auto auto ".concat(palette.gutter * 3 + 'px', " auto"),
      textAlign: 'center',
      background: palette.elErrorLight,
      paddingTop: palette.gutter + 'px',
      paddingBottom: palette.gutter + 'px',
      paddingLeft: palette.gutter * 5 + 'px',
      paddingRight: palette.gutter * 5 + 'px',
      fontSize: palette.tsSmall,
      lineHeight: palette.tlSmall
    },
    service: {
      textAlign: 'center',
      paddingTop: palette.gutter * 4 + 'px',
      paddingBottom: palette.gutter * 4 + 'px'
    },
    global: {
      textAlign: 'center',
      fontSize: palette.tsLarge,
      lineHeight: palette.tlXLarge,
      margin: '0 auto',
      width: 'auto',
      minWidth: 'auto'
    }
  };
}